/**
 * 模块: SearchPerformanceTabs Table Columns
 * 职责: 表格列配置定义
 */

import * as columns from './columns';

export const {
  conversionAdvantageColumns,
  ctrAdvantageColumns,
  shareAdvantageColumns,
  priceAdvantageColumns,
  highPriorityOpportunityColumns,
  mediumPriorityOpportunityColumns,
} = columns;

export default columns;
